import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Building2, HardHat } from 'lucide-react';
import { ListSection, ListRow, PrimaryButton } from '../../components/RowList';
import SubmitBudgetButton from '../../components/SubmitBudgetButton';

// Module 5 — CAPEX (the "Growth" module).
const Capital = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full overflow-y-auto font-sans bg-slate-100 dark:bg-slate-900">
      <div className="max-w-6xl mx-auto px-6 py-10">

        <div className="mb-10 flex items-start justify-between gap-4">
          <div>
            <h1 className="m-0 text-3xl font-bold tracking-tight text-slate-900 dark:text-slate-100">Capital</h1>
            <p className="mt-2 text-base text-slate-500 dark:text-slate-400">
              Budget expansion projects and asset acquisitions — separate from, but linked to, operational cash flow.
            </p>
          </div>
          <SubmitBudgetButton module="MOD_5_CAPEX" />
        </div>

        <ListSection title="Capital Planning">
          <ListRow
            icon={Building2}
            title="Capital Programme"
            description="The five-year plan: opening work in progress, this year phased by month, and years 2-5 annually. Only year 1 reaches the cash flow and the depreciation schedule — the out-years are there so the programme can be seen whole."
            actions={<PrimaryButton onClick={() => navigate('/capital/projects')}>Open</PrimaryButton>}
          />
        </ListSection>

        {/* THE PHYSICAL REGISTER — what the business owns and has to look after.
            Deliberately NOT the depreciation schedule, which moved to Finance:
            what an asset cost and how long it is written off over is a financial
            policy decision, and this list is about the objects themselves. Both
            describe the same machines and they are different questions. */}
        <ListSection title="Assets">
          <ListRow
            icon={HardHat}
            title="Asset Register"
            description="Everything the business owns and maintains — machines, services, fleet — by site, area, class and criticality. Maintenance planning and capitalisation both hang off this list."
            actions={<PrimaryButton onClick={() => navigate('/capital/assets')}>Open</PrimaryButton>}
          />
        </ListSection>

      </div>
    </div>
  );
};

export default Capital;
